module.exports = __webpack_public_path__ + "static/media/sparkle_yellow.ad9afa11.png";